import { Box, Button, Stack, Typography } from '@mui/material';
import { useServerTranslation } from 'hooks/useServerTranslation';
import { ReactNode } from 'react';
import { useProductsContext } from 'stores/useProducts';

type ProductListingProps = {
    children: ReactNode[];
    loadMore: () => void;
};

export function ProductListing(props: ProductListingProps) {
    const { children, loadMore } = props;
    const { showing, total } = useProductsContext((store) => store);

    return (
        <Box>
            <Stack
                display="grid"
                gap={4}
                gridTemplateColumns={{
                    xs: '1fr',
                    sm: 'repeat(3, 1fr)',
                    md: 'repeat(3, 1fr)',
                    lg: 'repeat(4, 1fr)',
                }}
            >
                {children.map((child, index) => (
                    <Box key={index} data-testid={`product-listing-item-${index}`}>
                        {child}
                    </Box>
                ))}
            </Stack>
            <Pagination
                count={showing}
                total={total}
                onLoadMore={loadMore}
            />
        </Box>
    );
}

function Pagination(props: { count: number; total: number; onLoadMore: () => void }) {
    const { count, total, onLoadMore } = props;
    const shouldShowLoadMoreButton = count < total;

    const { t } = useServerTranslation();

    return (
        <Box textAlign="center" sx={{ margin: '60px 0' }}>
            <Typography marginBottom="1rem">{t('favourites.showing-count-of-total', { count, total })}</Typography>
            { shouldShowLoadMoreButton && (
                <Button variant="viewMore" onClick={onLoadMore}>
                    {t('common.button.show-more-products')}
                </Button>
            )}
        </Box>
    );
}
